export default "__VITE_ASSET__D2Ay8iq5__"